module.exports = __webpack_public_path__ + "img/cg_oldtown_alley.5ca2a47b.jpg";